<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 pb-4">
          <router-link
            :to="{ name: 'contacts.create' }"
            v-if="$allowedRoute('contacts.create')"
          >
            <b-button block variant="primary" outline size="lg">
              <i class="fas fa-plus"></i>
              Add
            </b-button>
          </router-link>
        </div>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body class="pt-0">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Search by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-input
                          id="exampleInputText1"
                          type="text"
                          placeholder="enter name, email or phone"
                          size="sm"
                          v-model="search"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Filter by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-select
                          plain
                          v-model="selectedStatus"
                          :options="statusOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select status</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-select
                          plain
                          v-model="selectedCompany"
                          :options="companyOptions"
                          size="sm"
                          class="mb-3"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null"
                              >select company</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-if="role === 'sales_manager'">
                <b-col>
                  <b-row>
                    <b-col>
                      <h5>Filter by user</h5>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <v-select
                        multiple
                        :closeOnSelect="false"
                        v-model="selectedUserIds"
                        :reduce="(user) => user.id"
                        label="email"
                        :options="users"
                      ></v-select>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="items"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                data-cy="contact-table"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(owner)="data">
                  <Avatar
                    :imageUrl="data.item.owner.avatar_url"
                    :backgroundColor="data.item.owner.avatar_color"
                    :initials="data.item.owner.initials"
                    :prettyName="data.item.owner.prettyName"
                    :small="true"
                  />
                </template>
                <template v-slot:cell(last_name)="data">
                  <router-link
                    v-if="data.item.owner_id === userId && isDebug"
                    :to="{
                      path: `/contacts/${data.item.id}`,
                    }"
                  >
                    <b-button variant="link" style="color: var(--iq-primary)" class="p-0 text-left">
                      {{ data.item.last_name | notAvailable }}
                    </b-button>
                  </router-link>
                  <h6 v-else>{{ data.item.last_name | notAvailable }}</h6>
                </template>
                <template v-slot:cell(first_name)="data">
                  <router-link
                    v-if="data.item.owner_id === userId && isDebug"
                    :to="{
                      path: `/contacts/${data.item.id}`,
                    }"
                  >
                    <b-button variant="link" style="color: var(--iq-primary)" class="p-0 text-left">
                      {{ data.item.first_name | notAvailable }}
                    </b-button>
                  </router-link>
                  <h6 v-else>{{ data.item.first_name | notAvailable }}</h6>
                </template>
                <template v-slot:cell(status)="data">
                  <ContactStatusBadge :status="data.value" />
                </template>
                <template v-slot:cell(cx)="data">{{ data.value }}</template>
                <template v-slot:cell(recency)="data">{{
                  data.value | formatDate | notAvailable
                }}</template>
                <template v-slot:cell(email)="data">{{ data.value }}</template>
                <template v-slot:cell(phone)="data">{{
                  data.value | notAvailable
                }}</template>
                <template v-slot:cell(action)="data">
                  <b-button
                    v-if="data.item.owner_id === userId"
                    variant="outline-success mr-2"
                    size="sm"
                    @click="$router.push(`/contacts/${data.item.id}/edit`)"
                  >
                    <i class="ri-ball-pen-fill m-0"></i>
                  </b-button>
                  <b-button
                    v-if="data.item.owner_id === userId"
                    @click="toDeleteItem = data.item"
                    variant="outline-danger"
                    size="sm"
                  >
                    <i class="ri-delete-bin-line m-0"></i>
                  </b-button>
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row d-flex justify-content-center">
        <b-pagination
          value="3"
          size="md"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
      <b-modal
        id="delete-modal"
        :visible="!!toDeleteItem"
        title="Delete contact"
        @hidden="toDeleteItem = null"
      >
        <p>
          Contact
          <strong>
            {{
              toDeleteContact
                ? `${toDeleteContact.first_name} ${toDeleteContact.last_name} (${toDeleteContact.email})`
                : null
            }}
          </strong>
          will be deleted.
        </p>
        <p>Are you sure?</p>
        <template #modal-footer="{}">
          <b-button
            size="sm"
            variant="outline-dark"
            @click="toDeleteItem = null"
            >Cancel</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            @click="deleteItem(toDeleteItem.id)"
            >Delete</b-button
          >
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { core } from "../../config/pluginInit";
import ContactStatusBadge from "./Components/ContactStatusBadge";
import DeletedBadge from "./Components/DeletedBadge";
import listCompanies from "./listCompanies.gql";
import listContacts from "./listContacts.gql";
import gql from "graphql-tag";
import { getAccountSync, isDebug } from "../../Utils/account";
import {getOwnerData} from "../../Utils/getOwnerData";
import Avatar from "./Components/Avatar.vue";

const DELETE_CONTACT = gql`
  mutation deleteContact($id: uuid!) {
    deleteContact(id: $id) {
      id
    }
  }
`;
const LIST_AVAILABLE_USERS = gql`
  query getMySalesPersons($adminId: uuid!){
    users (
      where: {
        role: {
          _eq: sales_person
        }
        organizations: {
          organization: {
            admin_id: {
              _eq: $adminId
            }
          }
        }
      }
    ){
      id
      email
      first_name
      last_name
    }
  }
`;

export default {
  name: "Contacts",
  data() {
    return {
      sortBy: "cx",
      sortDesc: true,
      search: "",
      perPage: 200,
      currentPage: 1,
      rows: null,
      contacts: [],
      error: false,
      loading: false,
      selectedStatus: null,
      selectedCompany: null,
      role: getAccountSync()?.defaultRole,
      userId: getAccountSync()?.userId,
      selectedUserIds: [],
      fields: [
        { key: "owner", label: "Owner", sortable: false },
        { key: "first_name", label: "First name", sortable: true },
        { key: "last_name", label: "Last name", sortable: true },
        { key: "company", label: "Company", sortable: false },
        { key: "status", label: "Status", sortable: true },
        isDebug() ? { key: "cx", label: "CX", sortable: true } : undefined,
        isDebug() ? { key: "recency", label: "Recency", sortable: true } : undefined,
        { key: "email", label: "E-mail", sortable: true },
        { key: "phone", label: "Phone", sortable: true },
        { key: "action", label: "Action", sortable: false }
      ],
      statusOptions: [
        { value: "ACTIVE", text: "Active" },
        { value: "UNSUBSCRIBED", text: "Unsubscribed" },
        { value: "UNCONFIRMED", text: "Unconfirmed" },
        { value: "DELETED", text: "Deleted" },
        { value: "BOUNCED", text: "Bounced" }
      ],
      toDeleteItem: null
    };
  },
  components: {
    ContactStatusBadge,
    DeletedBadge,
    Avatar
  },
  apollo: {
    contacts: {
      query: listContacts,
      fetchPolicy: "no-cache",
      variables() {
        const vars = {
          where: {},
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        if (this.sortBy !== "") {
          vars.order_by = {
            [this.sortBy]: this.sortDesc ? "desc" : "asc"
          };
        }

        // filter
        const searchPart = this.search
          ? {
              _or: [
                {
                  first_name: {
                    _ilike: `%${this.search}%`
                  }
                },
                {
                  last_name: {
                    _ilike: `%${this.search}%`
                  }
                },
                {
                  email: {
                    _ilike: `%${this.search}%`
                  }
                },
                {
                  phone: {
                    _ilike: `%${this.search}%`
                  }
                }
              ]
            }
          : null;

        const whereAttributes = [];
        if (this.selectedStatus) {
          whereAttributes.push({
            status: {
              _eq: this.selectedStatus
            }
          });
        }
        if (this.selectedCompany) {
          whereAttributes.push({
            company_id: {
              _eq: this.selectedCompany
            }
          });
        }
        if (this.selectedUserIds.length > 0) {
          whereAttributes.push({
            owner_id: {
              _in: this.selectedUserIds
            }
          });
        }

        const finalFilter = [];
        if (searchPart !== null) {
          finalFilter.push(searchPart);
        }
        if (whereAttributes.length > 0) {
          whereAttributes.forEach(att => finalFilter.push(att));
        }

        vars.where = {
          _and: finalFilter
        };

        return vars;
      },
      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.contacts_aggregate.aggregate.count;
        }
      }
    },
    companies: {
      query: listCompanies
    },
    users: {
      query: LIST_AVAILABLE_USERS,
      variables(){
        return {
          adminId: getAccountSync()?.userId,
        }
      }
    }
  },
  computed: {
    // items remaps campaigns for template
    items() {
      const d = this.contacts.map(contact => {
        return {
          id: contact.id,
          first_name: contact.first_name,
          last_name: contact.last_name,
          company: contact?.company?.name || "-",
          status: contact.status,
          email: contact.email,
          phone: contact.phone,
          cx: contact?.cx || "-",
          recency: contact?.recency,
          owner_id: contact.owner_id,
          owner: getOwnerData(contact.owner)
        };
      });
      return d;
    },
    companyOptions() {
      if (!this.companies) {
        return [];
      }
      return this.companies.map(i => ({
        value: i.id,
        text: i.name
      }));
    },
    toDeleteContact() {
      if (!this.toDeleteItem) {
        return null;
      }
      const c = this.items.find(i => i.id === this.toDeleteItem);
      if (!c) {
        return null;
      }
      return c;
    },
    isDebug() {
      return isDebug();
    }
  },
  methods: {
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_CONTACT,
          variables: {
            id
          }
        });
        this.$toast.success(`Contact deleted`);
        this.toDeleteItem = null;
        this.$apollo.queries.contacts.refetch();
      } catch (error) {
        this.$toast.error(`Failed to delete contact : ${error.message}`);
      }
    }
  },
  mounted() {
    core.index();
  }
};
</script>
